import React from "react";
import Modal from "react-bootstrap/Modal";
import Editor from "@monaco-editor/react";
const MachineOutputView = (props) => {
    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            scrollable
            className="modal-fullscreen"
            backdrop="static"
        >
            <Modal.Header closeButton>
                <div>
                    <div className="d-flex gap-2 align-items-center">
                        <Modal.Title id="contained-modal-title-vcenter">
                            {props.machinename} - Output Structure
                        </Modal.Title>
                    </div>
                </div>
            </Modal.Header>
            <Modal.Body>
                <Editor
                    language={"json"}
                    value={props.jsondata}
                    options={{
                        readOnly: true,
                        minimap: { enabled: false },
                    }}
                />
            </Modal.Body>
        </Modal>
    );
};

export default MachineOutputView;
